import React, { useContext } from 'react';
import classNames from 'classnames';
import brandPromiseSvgLogo from '../../../assets/logos/john-lewis-partners.svg';
import teaseSvgLogo from '../../../assets/logos/john-lewis-logo-linear.svg';
import styles from './logobp.scss';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';
import isMonetateGroup from '../../utils/monetate/isMonetateGroup';

export const logoAssetsPath = assetsPath => asset =>
  assetsPath ? `${assetsPath}/images/${asset.split('/').pop()}` : asset;

const getLogoSrc = (assetsPath, teaseLogoActive) => {
  const logoWithAssetsPath = logoAssetsPath(assetsPath);
  return logoWithAssetsPath(
    teaseLogoActive ? teaseSvgLogo : brandPromiseSvgLogo
  );
};

const LogoBP = ({ splashScreen }) => {
  const { envVars, features } = useContext(EnvVarsFeaturesContext);
  const teaseLogoActive = isMonetateGroup(features, 'enable tease logo');
  const logoSrc = getLogoSrc(envVars?.assetsPath || '', teaseLogoActive);

  return (
    <div
      className={classNames(styles.container, {
        [styles.container__expandedSearch]: splashScreen,
        [styles.container__tease]: teaseLogoActive,
      })}
      data-testid="logo-container"
    >
      <a className={styles.link} href="/">
        <img
          src={logoSrc}
          alt="John Lewis & Partners Home"
          className={styles.logo}
        />
      </a>
    </div>
  );
};

export default LogoBP;
